'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.load = load;
exports.save = save;
exports.uploadImage = uploadImage;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'jai20enmaths-cms/document/LOAD';
var LOAD_SUCCESS = 'jai20enmaths-cms/document/LOAD_SUCCESS';
var LOAD_FAIL = 'jai20enmaths-cms/document/LOAD_FAIL';
var SAVE = 'jai20enmaths-cms/document/SAVE';
var SAVE_SUCCESS = 'jai20enmaths-cms/document/SAVE_SUCCESS';
var SAVE_FAIL = 'jai20enmaths-cms/document/SAVE_FAIL';
var IMAGE_UPLOAD = 'jai20enmaths-cms/document/IMAGE_UPLOAD';
var IMAGE_UPLOAD_SUCCESS = 'jai20enmaths-cms/document/IMAGE_UPLOAD_SUCCESS';
var IMAGE_UPLOAD_FAIL = 'jai20enmaths-cms/document/IMAGE_UPLOAD_FAIL';

var initialState = {
  loaded: false,
  saving: false,
  saved: false,
  uploadingImage: false,
  image: {},
  editing: {},
  saveError: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result,
        error: null
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      });
    case SAVE:
      return (0, _extends3.default)({}, state, {
        saving: true
      });
    case SAVE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        saving: false,
        saved: true,
        error: null
      });
    case SAVE_FAIL:
      return (0, _extends3.default)({}, state, {
        saving: false,
        saved: false,
        error: action.error
      });
    case IMAGE_UPLOAD:
      return (0, _extends3.default)({}, state, {
        uploadingImage: true
      });
    case IMAGE_UPLOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        uploadingImage: false,
        image: action.result,
        error: null
      });
    case IMAGE_UPLOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        uploadingImage: false,
        image: null,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.document && globalState.document.loaded;
}

function load(documentId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/document/' + documentId);
    } // params not used, just shown as demonstration
  };
}

function save(document) {
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    promise: function promise(client) {
      return client.patch('/document/' + document._id, { data: document });
    }
  };
}

function uploadImage(data) {
  return {
    types: [IMAGE_UPLOAD, IMAGE_UPLOAD_SUCCESS, IMAGE_UPLOAD_FAIL],
    promise: function promise(client) {
      return client.post('/document/' + data.documentId + '/image', { data: data.data });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/document.js
// module id = 159
// module chunks = 0